import { useEffect, useState } from "react";
import { Button, Grid } from "@mui/material";
import styles from "./styles";
import { DateRangePicker } from "@mui/lab";
import useStyles from "@hooks/useStyle";
import { MvButtonGroupPropsInterface } from "@mv-components/types";
import { Typography } from "..";

const ButtonGroup = (props: MvButtonGroupPropsInterface) => {
	const {
		options,
		selectedValueIndexes,
		extraClass,
		isRadio = false,
		buttonClassName = "",
		buttonTextClassName,
		onChange,
		itemKey,
		label,
		noLocalSelection,
		forceResetActiveButton,
		disabled,
	} = props;
	const { classes, cx } = useStyles(styles) as any;
	const [activeButtons, setActiveButtons] = useState<any>([]);

	useEffect(() => {
		if (selectedValueIndexes) {
			setActiveButtons(selectedValueIndexes);
		}
	}, [selectedValueIndexes]);

	useEffect(() => {
		if (forceResetActiveButton) {
			setActiveButtons([]);
		}
	}, [forceResetActiveButton]);
	const getNewValue = (i: number) => {
		if (isRadio) {
			return activeButtons.includes(i) ? [] : [i];
		} else {
			return activeButtons.includes(i)
				? activeButtons.filter((index: number) => index !== i)
				: [...activeButtons, i];
		}
	};

	const handleChange = (e: any, i: number) => {
		const newValue = getNewValue(i);
		if (!newValue) {
			return;
		}
		onChange(itemKey)(e, newValue);
		if (!noLocalSelection) {
			setActiveButtons(newValue);
		}
	};

	const handleDateChange = (i: number, date: any) => {
		let newValue = getNewValue(i);
		newValue = newValue ?? activeButtons;

		if (!date[0] || !date[1]) {
			const updateActiveButtonIndex = activeButtons.filter(
				(activeButtonIndex: number) => activeButtonIndex !== i
			);
			onChange(i, itemKey)({}, date, updateActiveButtonIndex);
			return setActiveButtons(updateActiveButtonIndex);
		}

		setActiveButtons(newValue);
		onChange(i, itemKey)({}, date, newValue);
	};

	if (!activeButtons) {
		return null;
	}
	return (
		<>
			{!!label && (
				<div>
					<Typography className={cx(classes.t14, classes.marginBottom8)}>{label}</Typography>
				</div>
			)}
			<Grid container className={cx(extraClass)}>
				{options?.map((buttonControl, i: number) => {
					const isActive = activeButtons.includes(i);

					const ButtonText = (
						<Typography
							className={cx(
								classes.groupButtonText,
								classes[buttonTextClassName ?? ""],
								isActive ? classes.groupButtonTextActive : null
							)}
							key={i}
						>
							{buttonControl.label}
						</Typography>
					);

					if (
						buttonControl.optionType === "pastDatePicker" ||
						buttonControl.optionType === "futureDatePicker" ||
						buttonControl.optionType === "fullDatePicker"
					) {
						return (
							<DateRangePicker
								key={i}
								disableFuture={buttonControl.optionType === "futureDatePicker"}
								disablePast={buttonControl.optionType === "pastDatePicker"}
								calendars={1}
								value={buttonControl.dateValue}
								onChange={(date: any) => handleDateChange(i, date)}
								renderInput={(startProps: any) => {
									return (
										<>
											<Button
												onClick={startProps.inputProps.onFocus}
												className={cx(
													classes.groupButton,
													classes[buttonClassName],
													isActive ? classes.groupButtonActive : null
												)}
											>
												{ButtonText}
											</Button>
										</>
									);
								}}
							/>
						);
					}
					return (
						<Button
							key={i}
							{...buttonControl}
							className={cx(
								classes.groupButton,
								classes[buttonClassName],
								isActive ? classes.groupButtonActive : null
							)}
							onClick={(e) => {
								handleChange(e, i);
							}}
							disabled={disabled}
						>
							{ButtonText}
						</Button>
					);
				})}
			</Grid>
		</>
	);
};

export default ButtonGroup;
